namespace('IO.Views.NodeGroups', function (exports) {
  'use strict';
  exports.Show = IO.Views.NodeGroups.New;
});
